import options from './left.component';

export default {
    selector: 'dtNavbarLeft',
    options
};
